module.exports = __webpack_public_path__ + "static/kw51_img_9-314a72417534aa6d783d74ba4bccc3c4.png";